import { SplashScreen, ISplashScreenProps } from '@cmctechnology/webinvest-design-system';
import { useDisableZoom } from '@cmctechnology/webinvest-store-frontend';
import React from 'react';

export const SplashScreenZoomDisabledWrapper: React.FC<ISplashScreenProps> = (props) => {
  useDisableZoom();
  return <SplashScreen {...props}></SplashScreen>;
};
